//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  name: 'app',
  mounted () {
    if (this.mobile) {
      require('src/assets/setRem');
    }
  },
  computed: mapState(['mobile']),
  watch: {
    mobile (newVal) {
      if (newVal) {
        require('src/assets/setRem');
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue